import * as React from "react";
import { Redirect, Route } from "react-router-dom";

import Audit from "../pages/audit/Audit";
import { InventorySearch } from "../pages/inventorySearch/InventorySearch";
import Locations from "../pages/locationSearch/Locations";
import { Maps } from "../pages/yardMap/Maps";
import { GateQueue } from "../pages/gateQueue/GateQueue";
import { ProcessShipments } from "../pages/inboundShipments/ProcessShipments";
import { ProcessWorkOrders } from "../pages/workOrder/ProcessShipments";
import ProcessOutboundShipments from "../pages/outboundShipments/ProcessOutboundShipments";
import { Tasks } from "../pages/myTasks/MyTasks";
import { YardUtilization } from "../pages/utilization/YardUtilization";
import { Documents } from "../pages/documents/Documents";
import Logout from "../../components/Logout";
import NetworkError from "../../components/NetworkError";
import { TrackLocationContainer } from "../pages/trackManagement/TrackLocation";
import { getEnv, isAuthorized } from "../../utils/appUtils";
import { sessionYardRunsDriverCheckIn } from "../../utils/gateAccess";
import { AclType } from "../../utils/constants";

const showWorkOrders = getEnv() === "dev";

const routes = [
  // Checked at render, not at module load: the routes list is built before the
  // session exists. Crew and supervisors reach the queue only once Gate
  // Management is granted; managers pass every permission. The yard test is
  // second because it is not about this user: a yard that checks trucks in at
  // the office has no queue for anyone to reach.
  <Route
    path="/gateQueue"
    render={(props) =>
      isAuthorized(AclType.GATE_MANAGEMENT) &&
      sessionYardRunsDriverCheckIn() ? (
        <GateQueue {...props} />
      ) : (
        <Redirect to="/" />
      )
    }
  />,
  <Route
    path="/processShipments"
    render={(props) => <ProcessShipments {...props} />}
  />,
  ...(showWorkOrders
    ? [
        <Route
          path="/processWorkOrders"
          render={(props) => <ProcessWorkOrders {...props} />}
        />,
      ]
    : []),
  <Route
    path="/processOutboundShipments"
    render={(props) => <ProcessOutboundShipments {...props} />}
  />,
  <Route path="/locations" render={(props) => <Locations {...props} />} />,
  <Route path="/search" render={(props) => <InventorySearch {...props} />} />,
  <Route path="/maps" render={(props) => <Maps {...props} />} />,
  <Route path="/processAudit" render={(props) => <Audit {...props} />} />,
  <Route path="/mytasks" render={(props) => <Tasks {...props} />} />,
  <Route
    path="/utilization"
    render={(props) => <YardUtilization {...props} />}
  />,
  <Route
    path="/trackManagement"
    render={(props) => <TrackLocationContainer {...props} />}
  />,
  <Route path="/documents" render={(props) => <Documents {...props} />} />,
  <Route exact path="/logout" render={() => <Logout />} />,
  <Route
    path="/networkError"
    render={(props) => <NetworkError {...props} />}
  />,
];

export default routes;
